<template>
    <div class="headContainer">
        <span class="title">
          <img src="../../static/images/logo.png" alt="" class="logo">
          
          {{ title }}</span>
        <span
            class="selCont"
            :class="index == activeIndex ? 'active' : ''"
            v-for="(item, index) in list"
            :key="index"
            @click="goRouter(item)"
            >{{ item.name }}</span
        >
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            title: "海南省公用品牌综合服务平台",
            list: [
                {
                    name: "首页",
                    value: 0,
                    path: "/home",
                    open: true,
                    newPage: false,
                },
                {
                    name: "区域公用品牌",
                    value: 1,
                    path: "/brandPublic",
                    open: true,
                    newPage: false,
                },
                {
                    name: "一镇一品",
                    value: 2,
                    path: "/brandPublicAlone",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌风采",
                    value: 3,
                    path: "/brandStyle",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌纪实",
                    value: 4,
                    path: "/brandSummary",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌矩阵",
                    value: 5,
                    path: "/brandMap",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌报告",
                    value: 6,
                    path: "/brandReport",
                    open: true,
                    newPage: false,
                },
                {
                    name: "品牌云图",
                    value: 7,
                    path: "daping.shuziqingyun.com/#/ppm",
                    open: true,
                    newPage: true,
                },
                // { name: "热点资讯", value: 7, path: "/news", open: true },
                // { name: "授权名录", value: 5, path: "/directory", open: true },
                // { name: "海南特产馆", value: 5, path: "/specialty", open: false },
                // { name: "关于平台", value: 7, path: "/about", open: true },
            ],
            activeIndex: 0,
        };
    },
    mounted() {
        this.getRouter();
    },
    watch: {
        $route(to, from) {
            this.getRouter();
        },
    },
    methods: {
        goRouter(item) {
            if (!item.open) {
                return this.$notify({
                    title: "提示",
                    message: "此模块暂时未开放",
                    type: "info",
                    duration: 3000,
                });
            }
            if (!item.newPage) {
               return this.$router.push(item.path);
            }
            if(item.newPage){
              return window.open('//'+item.path)
            }
        },
        getRouter(path) {
            let route = path ? path : this.$route.path;
            this.list.forEach((item, index) => {
                if (!route) {
                    return (this.activeIndex = 0);
                }
                if (item.path) {
                    if (route.search(item.path) != -1) {
                        return (this.activeIndex = index);
                    }
                }
            });
        },
    },
};
</script>

<style scope lang="scss">
@import "./index.scss";
</style>


// WEBPACK FOOTER //
// src/components/headCont/index.vue